var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('import',{attrs:{"import-url":"/api/attributes/import","template-url":"/admin/attributes/export","button-text":"Download Current Attributes"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }